import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlerticon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(1 0 0 -1 0 24)",
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("circle", {
			fill: "#C00",
			cx: 12,
			cy: 12,
			r: 12
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "translate(11 6.4)",
			fill: "#FFF",
			children: [/* @__PURE__ */ _jsx("circle", {
				fillRule: "nonzero",
				cx: 1,
				cy: 1,
				r: 1
			}), /* @__PURE__ */ _jsx("path", { d: "M0 3h2v8H0z" })]
		})]
	})
});
export default SvgAlerticon;
